import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=4fa0b670&scoped=true&lang=pug&"
import script from "./Scroll.vue?vue&type=script&lang=js&"
export * from "./Scroll.vue?vue&type=script&lang=js&"
import style0 from "./Scroll.vue?vue&type=style&index=0&id=4fa0b670&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0b670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fa0b670', component.options)
    } else {
      api.reload('4fa0b670', component.options)
    }
    module.hot.accept("./Scroll.vue?vue&type=template&id=4fa0b670&scoped=true&lang=pug&", function () {
      api.rerender('4fa0b670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview_area/built-in component/Scroll.vue"
export default component.exports